define('presentation/settings/webChats/validators/addWebChatWidgetViewModelValidator',[
    'common/specifications/validUrlAddressSpecification',
    'presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule'
], function () {
    return function () {
        const self = this;

        const ValidUrlAddressSpecification = require('common/specifications/validUrlAddressSpecification');
        const _validUrlAddressSpecification = new ValidUrlAddressSpecification();

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        let _addWebChatWidgetViewModel;
        let _addWebChatWidgetFacade;
        let _commonValidator = null;

        self.registerViewModel = (addWebChatWidgetViewModel, addWebChatWidgetFacade) => {
            _commonValidator = new CommonValidatorConstructor(addWebChatWidgetViewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("displayName")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addWebChatWidget:nameRequired');
            validationRules.field("launcherTextColor")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addWebChatWidget:launcherTextColorRequired')
                .addValidationI18n(_validateLauncherHexColor, 'addWebChatWidget:launcherTextColorInvalid');
            validationRules.field("launcherBackgroundColor")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addWebChatWidget:launcherBackgroundColorRequired')
                .addValidationI18n(_validateLauncherHexColor, 'addWebChatWidget:launcherBackgroundColorInvalid');
            validationRules.field("welcomeMessage")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addWebChatWidget:welcomeMessageRequired');
            validationRules.array("authorizedDomains")
                .arrayField("domain")
                .addValidationI18n(_validateAuthorizedDomain, 'addWebChatWidget:domainInvalid')
                .addValidationI18n(_isAuthorizedDomainUnique, 'addWebChatWidget:domainDuplicate');

            _addWebChatWidgetViewModel = addWebChatWidgetViewModel;
            _addWebChatWidgetFacade = addWebChatWidgetFacade;

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };

        const _validateAuthorizedDomain = (domain) => {
            if (_commonValidator.isStringWithValue(domain)) {
                return _validUrlAddressSpecification.isSatisfiedBy(domain.trim());
            } else {
                return true;
            }
        };

        const _isAuthorizedDomainUnique = (domain) => {
            const authorizedDomains = _addWebChatWidgetViewModel.authorizedDomains();
            const matchingDomains = authorizedDomains.filter((d) => {
                return d.domain().trim().toLowerCase() === domain.trim().toLowerCase();
            });
            return matchingDomains.length === 1;
        };

        const _validateLauncherHexColor = (color) => {
            return /^#([0-9a-f]{3}){1,2}$/i.test(color);
        };
    };
});

